export class PasteError extends Error {
  isPasteError = true;
}

export default PasteError;
